// @flow

export const findValueFromObject = (valueToFind: string, dataObject: Object) => valueToFind.split(' ').map((value) => {
  const accessors = value.split('.');
  let dataFound = { ...dataObject };
  accessors.forEach((accessor) => { dataFound = dataFound[accessor]; });
  return dataFound;
}).reduce((origin, added) => `${origin ? origin.toString() : ''} ${added ? added.toString() : ''}`);
